export enum WalletActionTypes {
    FETCH_WALLET_START = "FETCH_WALLET_START",
    WALLET_UPDATE = "WALLET_UPDATE",
}
